// general manual: https://github.com/axios/axios
// rest resource code - from this page https://github.com/axios/axios/issues/894

import http from 'axios'

/**
 * create vue-resource's resource like object
 *
 * Default Actions
 *   get: {method: 'GET'}
 *   save: {method: 'POST'}
 *   query: {method: 'GET'}
 *   update: {method: 'PUT'}
 *   delete: {method: 'DELETE'}
 *
 * @param path the resource path
 * @param http axios instance
 * @param actions custom actions
 * @returns the resource object
 */

export default function (path, actions) {
  var obj = {
    val: {}, // это объект внутри restResource который ссодержит собственно значение этого ресурса
    get: id => http.get(path + '/' + id),
    query: params => http.get(path + '/findBugfixed', {params}),
    save: function () {
      // console.log(this.val) // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
      /* создаем если нет id или update существующего на сервере */
      if (this.val.id == null) {
        // console.log('1') // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        // console.log('restResource save NEW entity. typeof val.value = ' + typeof this.val.value)
        // console.log('restResource save NEW entity. val.value = ' + typeof this.val.value)
        return http.post(path, this.val)
      }
      // console.log('2') // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
      // console.log('restResource save of EXISTED entity. typeof val.value = ' + typeof this.val.value)
      // console.log('restResource save of EXISTED entity. val.value = ' + typeof this.val.value)
      return http.put(path + '/' + this.val.id, this.val)
    },
    // update: (id, obj) => http.put(path + '/' + id, obj),
    delete: function () {
      return http.delete(path + '/' + this.val.id)
    }
  }
  return Object.assign(obj, actions)
}



// WEBPACK FOOTER //
// ./src/technical/restResource.js